<template>
  <div class="container">
    <div class="before-you-go-container">
      <span class="before-you-go">
        Before you go, consider these special offers:
      </span>
    </div>
    <div class="row">
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Renew at a Discounted Price</label>
          </div>
          <div class="cancellation-options-body most-popular trendsreport">
            <div class="insider-most-popular">
              <p class="most-popular-text">MOST POPULAR</p>
            </div>
            <ul class="cancellation-options-list">
              <li>
                Renew your annual subscription for only ${{
                  unsubscribe_promo_price
                }}
              </li>
              <li>${{ price }} for following years</li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="
                has_used_trendsreport_promo ? 'button-grey' : 'button-green'
              "
              v-on:click="annualSubscription"
            >
              PURCHASE ANNUAL
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Stay Current for Less with the ITR insider™</label>
          </div>
          <div class="cancellation-options-body-tr">
            <ul class="cancellation-options-list">
              <li>Unsubscribe from Trends Report subscription</li>
              <li>
                Sign up at the low cost of ${{ insider_price }}/month, and
                receive:
              </li>
              <ul class="child-list">
                <li class="child-list">Topical webinars</li>
                <li class="child-list">Economic Forecast Dashboard</li>
                <li class="child-list">Monthly ITR Advisor™</li>
              </ul>
              <li>Receive first month for ${{ insider_promo_price }}!</li>
            </ul>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="has_insider ? 'button-grey' : 'button-green'"
              v-on:click="switchToInsider"
            >
              SWITCH TO INSIDER
            </a>
          </div>
        </div>
      </div>
      <div class="col-large-4">
        <div class="cancellation-options">
          <div class="cancellation-options-header">
            <label>Keep up with ITR Economics - join our mailing list</label>
          </div>
          <div class="cancellation-options-body updates">
            <ul class="cancellation-options-list">
              <li>Unsubscribe from Trends Report subscription</li>
              <li>
                Sign up for updates via our blogs, TrendsTalk podcast episodes,
                and more!
              </li>
            </ul>
            <div class="insider-cancellation-checkbox">
              <input
                type="checkbox"
                id="i-agree-checkbox"
                class="insider-cancellation-checkbox-input"
                v-model="iAgreeChecked"
              />
              <label
                for="i-agree-checkbox"
                class="insider-cancellation-checkbox-label"
              >
                I agree to receive other communications from ITR Economics.
                <img
                  src="/images/question-mark-gray.png"
                  class="img-fluid"
                  title="ITR Economics is committed to protecting your privacy. Please review our privacy policy to learn more. By checking this box, you consent to our contacting you and to our storing and processing the personal information you have entered above."
                />
              </label>
            </div>
          </div>
          <div class="cancellation-submit">
            <a
              v-bind:class="iAgreeChecked ? 'button-green' : 'button-grey'"
              v-on:click="updatesSignUp"
            >
              SIGN UP
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'InsiderCancellationOptionsComponent',
    props: {
      product_to_unsubscribe: String,
      unsubscribe_promo_price: String,
      insider_price: String,
      insider_promo_price: String,
      price: String,
      has_insider: Boolean,
      has_used_trendsreport_promo: Boolean,
    },
    data: function () {
      return {
        iAgreeChecked: false,
      };
    },
    methods: {
      annualSubscription: function () {
        if (!this.has_used_trendsreport_promo) {
          axios
            .post(
              '/dashboard/cancelation/options/' + this.product_to_unsubscribe
            )
            .then(function (response) {
              window.location.href =
                '/dashboard/trendsreport-annual-subscription/';
            })
            .catch(function (error) {
              window.location.href = '/dashboard/contact-customer-care-error/';
            });
        }
      },
      switchToInsider: function () {
        if (!this.has_insider) {
          axios
            .post(
              '/dashboard/cancelation/options/switch-to-insider/' +
                this.product_to_unsubscribe
            )
            .then(function (response) {
              window.location.href =
                '/dashboard/cancelation/options/switch-to-insider/' +
                this.product_to_unsubscribe;
            })
            .catch(function (error) {
              window.location.href = '/dashboard/contact-customer-care-error/';
            });
        }
      },
      updatesSignUp: function () {
        if (this.iAgreeChecked) {
          axios
            .post('/dashboard/unsubscribe/' + this.product_to_unsubscribe)
            .then(function (response) {
              window.location.href = '/dashboard/newsletter-signup';
            })
            .catch(function (error) {
              window.location.href = '/dashboard/contact-customer-care-error/';
            });
        }
      },
    },
  };
</script>
